import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AccountTouchPointSummary } from '@eucoms/customer-touchpoints-tracker';
import { CustomerTouchPoint } from '@eucoms/customer-touchpoints-tracker';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnChanges {
  @Input() data: CustomerTouchPoint | AccountTouchPointSummary;

  deepLinkUrl: string = '';
  copyStatus: string = '';

  constructor(private router: Router) {}

  isTouchpoint(data: CustomerTouchPoint | AccountTouchPointSummary) {
    return 'processingContext' in data;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.buildDeepLink();
      this.copyStatus = '';
    }
  }

  private buildDeepLink(): void {
    if (!this.data?.id || !this.data?.accountNumber) {
        this.deepLinkUrl = '';
        return;
    }

    const basePath = this.router.url.split('?')[0];
    if(this.isTouchpoint(this.data)) {
        //construct touchpoint type link
        this.deepLinkUrl = `${window.location.origin}${basePath}?touchpointId=${encodeURIComponent(this.data.id)}&accountNumber=${encodeURIComponent(this.data.accountNumber)}`;
    } else {
        // construct summary type link
        this.deepLinkUrl = `${window.location.origin}${basePath}/account-number/${encodeURIComponent(this.data.accountNumber)}`;
    }
  }

  copyLink(): void {
    if (!this.deepLinkUrl) return;
    navigator.clipboard.writeText(this.deepLinkUrl)
      .then(() => this.copyStatus = 'Copied!')
      .catch(() => this.copyStatus = 'Copy failed.');
    setTimeout(() => { this.copyStatus = ''; }, 2500);
  }
}
